import client from "../../../api/client";

export default async function createRoomListing(payload) {
  const response = await client.post("/room-listings", payload);
  return response.data;
}